import {Injectable} from '@angular/core';
import {Observable, Subject} from "rxjs";

@Injectable()
export class CustomAlertService {
    subject = new Subject<any>();
    constructor() {
    }

    setCustomMessage(objeto, time = 3500) {
        this.subject.next({mensaje: objeto, tiempo: time});
    }

    getCustomService(): Observable<any> {
        return this.subject.asObservable();
    }
}
